export const MINOR_SWORDS: ITarotCard[] = [
  {
    id: 50,
    rank: "1",
    numeral: "I",
    name: "Ace of Swords",
    arcana: "swords",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/swords/ace_of_swords.svg",
    wordpressId: "2443",
  },
  {
    id: 51,
    rank: "2",
    numeral: "II",
    name: "Two of Swords",
    arcana: "swords",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/swords/two_of_swords.svg",
    wordpressId: "2445",
  },
  {
    id: 52,
    rank: "3",
    numeral: "III",
    name: "Three of Swords",
    arcana: "swords",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/swords/three_of_swords.svg",
    wordpressId: "2450",
  },
  {
    id: 53,
    rank: "4",
    numeral: "IV",
    name: "Four of Swords",
    arcana: "swords",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/swords/four_of_swords.svg",
    wordpressId: "2455",
  },
  {
    id: 54,
    rank: "5",
    numeral: "V",
    name: "Five of Swords",
    arcana: "swords",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/swords/five_of_swords.svg",
    wordpressId: "2460",
  },
  {
    id: 55,
    rank: "6",
    numeral: "VI",
    name: "Six of Swords",
    arcana: "swords",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/swords/six_of_swords.svg",
    wordpressId: "2465",
  },
  {
    id: 56,
    rank: "7",
    numeral: "VII",
    name: "Seven of Swords",
    arcana: "swords",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/swords/seven_of_swords.svg",
    wordpressId: "2472",
  },
  {
    id: 57,
    rank: "8",
    numeral: "VIII",
    name: "Eight of Swords",
    arcana: "swords",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/swords/eight_of_swords.svg",
    wordpressId: "2477",
  },
  {
    id: 58,
    rank: "9",
    numeral: "IX",
    name: "Nine of Swords",
    arcana: "swords",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/swords/nine_of_swords.svg",
    wordpressId: "2479",
  },
  {
    id: 59,
    rank: "10",
    numeral: "X",
    name: "Ten of Swords",
    arcana: "swords",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/swords/ten_of_swords.svg",
    wordpressId: "2484",
  },
  {
    id: 60,
    rank: "11",
    numeral: "XI",
    name: "Page of Swords",
    arcana: "swords",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/swords/page_of_swords.svg",
    wordpressId: "2489",
  },
  {
    id: 61,
    rank: "12",
    numeral: "XII",
    name: "Knight of Swords",
    arcana: "swords",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/swords/knight_of_swords.svg",
    wordpressId: "2509",
  },
  {
    id: 62,
    rank: "13",
    numeral: "XIII",
    name: "Queen of Swords",
    arcana: "swords",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/swords/queen_of_swords.svg",
    wordpressId: "2513",
  },
  {
    id: 63,
    rank: "14",
    numeral: "XIV",
    name: "King of Swords",
    arcana: "swords",
    image:
      "https://storage.googleapis.com/tarot-svg/minor_arcana/swords/king_of_swords.svg",
    wordpressId: "2516",
  },
];
